import { createResourceActions } from "src/redux_resources_v1";

export const assessmentSchemasResourceActions = createResourceActions(
  "assessmentSchemas"
);
